import { Typography } from "@mui/material";
import { memo } from "react";
import "./Footer.scss";
import React from "react";
import { Riverbed_Technology_All_rights_reserved } from "../../constant/String";

const FooterComponent = () => (
  <>
    <footer className="footer" data-testid="footer">
      <Typography variant="body1" sx={{ marginBottom: "1.35rem" }}>
        &#169; {new Date().getFullYear()} {Riverbed_Technology_All_rights_reserved}
      </Typography>
    </footer>
  </>
);

export default memo(FooterComponent);
